import React, { FC } from 'react';
import { CalendarListBaseProps, CalendarMarkingProps } from './types';

export const CalendarList: FC<CalendarMarkingProps & CalendarListBaseProps> = () => {
  return <></>;
};
